var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.25H3.25C2.375 13.25 1.66667 12.5417 1.66667 11.6667V4.08333C1.66667 3.20833 2.375 2.5 3.25 2.5H15.9167C16.7917 2.5 17.5 3.20833 17.5 4.08333V8.33333",
    stroke: "#4D5E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9825 6.6425C11.755 7.415 11.755 8.66833 10.9825 9.44167C10.21 10.2142 8.95667 10.2142 8.18333 9.44167C7.41083 8.66917 7.41083 7.41583 8.18333 6.6425C8.95667 5.86917 10.21 5.86917 10.9825 6.6425",
    stroke: "#4D5E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 14V11.6667C18.3333 11.0217 17.0267 10.5 15.4167 10.5C13.8067 10.5 12.5008 11.0225 12.5 11.6667V16.3333C12.5008 16.9775 13.8058 17.5 15.4167 17.5C17.0275 17.5 18.3325 16.9775 18.3333 16.3333V11.6667",
    stroke: "#4D5E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5008 11.667C12.5008 12.3112 13.8067 12.8337 15.4175 12.8337C17.0283 12.8337 18.3333 12.3112 18.3333 11.667",
    stroke: "#4D5E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5008 14C12.5008 14.6442 13.8067 15.1667 15.4175 15.1667C17.0283 15.1667 18.3342 14.6442 18.3342 14",
    stroke: "#4D5E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.8337H4.16667",
    stroke: "#4D5E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.99967H14.1667",
    stroke: "#4D5E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon);
export default __webpack_public_path__ + "static/media/MoneyIcon.1771dffbdf5b76ffe30858faf69fe753.svg";
export { ForwardRef as ReactComponent };